import React from 'react'
import Button from '../../../Button'
import './AskVisoActions.scss'

const AskVisoActions = ({ color, onSubmit, submitLabel = 'Submit', onCancel, cancelDisabled, submitDisabled, children }) => {

  return (
    <div className='ask-viso-chat-actions'>
      {children && <div className='ask-viso-chat-actions__content'>{children}</div>}
      {onCancel &&
        <button
          onClick={onCancel}
          className='ask-viso__cancel viso-text-label'
          disabled={cancelDisabled}
        >
          Cancel
        </button>
      }
      <Button
        id='askVisoSubmit'
        onClick={onSubmit}
        color={color}
        className='button button_sm ask-viso__button ask-viso__button--label-only'
        disabled={submitDisabled}
      >
        {submitLabel}
      </Button>
    </div>
  )
}

export default AskVisoActions